<template>
  <div class="brands-slider">
    <div class="brands-slider__content container">
      <div class="top flex al-center between">
        <div class="brands-slider__title font-34 bold uppercase">
          {{ _.get(contentData, "conf.header.title") }}
        </div>
        <a
          v-if="_.get(contentData, `conf.header.full_list_url`)"
          :href="_.get(contentData, `conf.header.full_list_url`)"
          class="view-all uppercase pointer"
        >
          {{ _.get(contentData, "conf.header.full_list_title") }}

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="7.857"
            height="10"
            viewBox="0 0 7.857 10"
          >
            <path
              id="Icon_material-play-arrow"
              data-name="Icon material-play-arrow"
              d="M12,7.5v10l7.857-5Z"
              transform="translate(-12 -7.5)"
              fill="#4d4d4f"
            />
          </svg>
        </a>
      </div>

      <swiper
        ref="brandsSliderGallery"
        class="brands-slider-gallery"
        :options="swiperOptions"
      >
        <swiper-slide
          class="single-slide"
          v-for="(brand, index) in _.get(contentData, 'data.list')"
          :key="index"
        >
          <div class="brand-card">
            <router-link
              tag="div"
              :to="$store.getters['main/getSingleUrl'](brand)"
              class="brand-card__image"
            >
              <picture>
                <source
                  media="(max-width: 767px)"
                  :srcset="`${_.get(brand, 'slider_image[0].devices.mobile')}`"
                />
                <source
                  media="(max-width: 1023px)"
                  :srcset="`${_.get(brand, 'slider_image[0].devices.tablet')}`"
                />
                <img
                  :src="_.get(brand, 'slider_image[0].devices.desktop')"
                  alt="image"
                />
              </picture>
            </router-link>
            <div class="brand-card__content">
              <div class="title font-34 bold text-overflow-hidden-2">
                {{ _.get(brand, "front_title") }}
              </div>
              <!-- <div class="teaser  uppercase">
                {{ $fn.tr("სამუშაო საათები") }}:
                {{
                  _.get(brand, "working_hours[0].hrs[0]") +
                    " - " +
                    _.get(brand, "working_hours[0].hrs[1]")
                }}
              </div> -->
              <router-link
                :to="$store.getters['main/getSingleUrl'](brand)"
                class="visit uppercase pointer bold"
              >
                {{ $fn.tr("ვრცლად") }}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="7.857"
                  height="10"
                  viewBox="0 0 7.857 10"
                >
                  <path
                    id="Icon_material-play-arrow"
                    data-name="Icon material-play-arrow"
                    d="M12,7.5v10l7.857-5Z"
                    transform="translate(-12 -7.5)"
                    fill="#4d4d4f"
                  />
                </svg>
              </router-link>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-navigation-button white swiper-prev">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7.857"
          height="10"
          viewBox="0 0 7.857 10"
        >
          <path
            id="Icon_material-play-arrow"
            data-name="Icon material-play-arrow"
            d="M12,7.5v10l7.857-5Z"
            transform="translate(-12 -7.5)"
            fill="#fff"
          />
        </svg>
      </div>

      <div class="swiper-navigation-button white swiper-next">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7.857"
          height="10"
          viewBox="0 0 7.857 10"
        >
          <path
            id="Icon_material-play-arrow"
            data-name="Icon material-play-arrow"
            d="M12,7.5v10l7.857-5Z"
            transform="translate(-12 -7.5)"
            fill="#fff"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import OfferCard from "./OfferCard.vue";
export default {
  components: { OfferCard },
  props: ["contentData"],
  data() {
    return {
      swiperOptions: {
        autoplay: {
          delay: 2500
        },
        loop: true,
        speed: 800,
        slidesPerView: 3,
        spaceBetween: 30,
        watchOverflow: true,
        navigation: {
          nextEl: ".brands-slider .swiper-next",
          prevEl: ".brands-slider .swiper-prev"
        },
        breakpoints: {
          320: {
            slidesPerView: 1
          },
          510: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 2
          },
          1023: {
            slidesPerView: 3
          }
        }
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.brands-slider {
  padding-top: 144px;
  padding-bottom: 144px;
  // background: $white;
  background: #f7f7f7;
  @media (max-width: 1599px) {
    padding-top: 130px;
    padding-bottom: 165px;
  }
  @media (max-width: 1439px) {
    padding-top: 92px;
    padding-bottom: 110px;
  }
  @media (max-width: 1023px) {
    padding-top: 55px;
    padding-bottom: 55px;
  }
  @media (max-width: 767px) {
    padding-bottom: 124px;
  }
  .view-all {
    color: $black;
  }
  &__content {
    position: relative;
    @media (max-width: 767px) {
      padding-bottom: 30px;
      border-bottom: 1px solid rgba(77, 77, 79, 0.1);
      .view-all {
        position: absolute;
        bottom: -70px;
        right: 15px;
      }
    }
  }
  .brands-slider-gallery {
    overflow: visible;
  }
  .brand-card {
    &__image {
      width: 100%;
      height: 610px;
      position: relative;
      cursor: pointer;
      overflow: hidden;

      &:hover {
        img {
          transform: scale(1.1, 1.1);
        }
      }
      @media (max-width: 1599px) {
        height: 442px;
      }
      // @media (max-width: 1355px) {
      //   height: 375px;
      // }
      @media (max-width: 1023px) {
        height: 430px;
      }
      @media (max-width: 767px) {
        height: 375px;
      }

      img {
        width: 100%;
        height: 100%;
        position: absolute;
        object-fit: cover;
        transition: 0.3s linear;
        transform-origin: center center;
      }
    }
    &__content {
      padding-top: 30px;
      .title {
        color: $black;
        margin-bottom: 20px;
        height: 80px;
      }
      .teaser {
        color: #4d4d4f;
        margin-bottom: 34px;
      }
      .visit {
        color: $black;
        svg {
          margin-left: 10px;
          path {
            transition: 0.4s ease;
          }
        }
        transition: 0.4s ease;

        &:hover {
          color: $red;
          svg {
            path {
              fill: $red;
            }
          }
        }
      }
    }
  }
  .top {
    padding-bottom: 55px;
    @media (max-width: 767px) {
      padding-bottom: 34px;
      .brands-slider__title {
        font-size: 21px;
      }
    }
  }
}
// .brand-card__image:hover ~ .brand-card {
//   background: red;
//   box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.16);
// }
</style>
